import { LabLostAndFoundUpload } from 'api/labs';
import {
  buildOwnCaseManifestDraft,
  buildSingleCaseManifestDraft,
} from 'components/StudyDashboard/CaseManifest/dialogState';
import { getOrganizationEntryUrl } from 'components/StudyDashboard/CaseManifest/organizationEntry';
import { OrganizationReturnDescriptor } from 'components/StudyDashboard/CaseManifest/organizationTypes';
import { filter, map, size } from 'lodash';
import { Slide } from 'interfaces/slide';

const getFileName = (objectKey: string) => objectKey.split('/').pop() || objectKey;

const buildManifestSlides = ({
  rows,
  labId,
  targetStudyId,
}: {
  rows: LabLostAndFoundUpload[];
  labId: string;
  targetStudyId: string;
}): Slide[] =>
  map(rows, (row) => ({
    id: '',
    labId,
    studyId: targetStudyId,
    sourceStudyId: row.sourceStudyId,
    originalFileName: getFileName(row.objectKey),
    createdAt: row.uploadedAt,
  }));

export const getManifestDialogUrlForLostUploads = ({
  uploadRows,
  groupIntoSingleCase,
  labId,
  targetStudyId,
  returnTo,
}: {
  uploadRows: LabLostAndFoundUpload[];
  groupIntoSingleCase: boolean;
  labId: string;
  targetStudyId: string;
  returnTo?: OrganizationReturnDescriptor;
}) => {
  const rowsWithSlideIds = filter(uploadRows, (row) => Boolean(row.resolvedSlideId));
  const rowsWithoutSlideIds = filter(uploadRows, (row) => !row.resolvedSlideId);
  const manifestSlides = buildManifestSlides({ rows: rowsWithoutSlideIds, labId, targetStudyId });
  const manualManifestSlideIdsToLoad = map(rowsWithSlideIds, (row) => String(row.resolvedSlideId));

  if (size(manifestSlides) === 0 && size(manualManifestSlideIdsToLoad) === 0) {
    return null;
  }

  const manualManifestCases = groupIntoSingleCase
    ? buildSingleCaseManifestDraft({ slides: manifestSlides, labId })
    : buildOwnCaseManifestDraft({ slides: manifestSlides, labId });

  return getOrganizationEntryUrl({
    studyId: targetStudyId,
    labId,
    returnTo: returnTo || { origin: 'lostAndFound', labId, studyId: targetStudyId },
    manifestState: {
      manualManifestCases,
      manualManifestSlideIdsToLoad,
      manualManifestGroupIntoSingleCase: groupIntoSingleCase,
    },
  });
};
